import Toggle, { ToggleProps } from './Toggle'
export { Toggle, type ToggleProps }
export default Toggle
